export default "__VITE_ASSET__D7hh5uPW__"